<template>
  <header class="admin-header">
    <div class="logo-section">
      <div class="logo-icon"><span class="logo-text">P</span></div>
      <h1 class="logo-title">PharmAID</h1>
      <span class="header-badge">管理后台</span>
    </div>
    <div class="admin-header-spacer" />
    <a-button type="default" size="small" class="admin-back-btn" @click="$router.push('/dashboard/5')">
      <template #icon><ExternalLink :size="14" /></template>
      返回前台
    </a-button>
  </header>
</template>

<script>
import { ExternalLink } from 'lucide-vue-next'

export default {
  name: 'AdminHeader',
  components: { ExternalLink },
}
</script>
